<template>
  <div>
    <v-chip :disabled="selectedTags.length === 0" small class="mr-3" @click.stop="selectedTags = []">{{ $t('removeTagsSelection') }}</v-chip>

    <v-chip-group v-model="selectedTags" column multiple color="accent">
      <v-chip filter dark v-for="tag in tags" :key="tag.id" :value="tag.id" small class="mr-1 text--white">{{ tag.name }}</v-chip>
    </v-chip-group>
  </div>
</template>

<script>
export default {
  name: 'TagsSelection',
  props: {
    tags: { type: Array, default: () => [] },
  },
  computed: {
    selectedTags: {
      // getter
      get() {
        return this.$store.state.documents.selectedTags;
      },
      // setter
      set(value) {
        this.$store.commit('documents/setSelectedTags', { value });
      },
    },
  },
};
</script>

<style></style>
